Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e,
    t = require("react"),
    n = (e = t) && "object" == typeof e && "default" in e ? e.default : e,
    r = require("rive-js"),
    _i = function i() {
  return (_i = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var i in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
      }
    }

    return e;
  }).apply(this, arguments);
};

function a(e, t) {
  var n = {};

  for (var r in e) {
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  }

  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;

    for (r = Object.getOwnPropertySymbols(e); i < r.length; i++) {
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
    }
  }

  return n;
}

function u(e) {
  var t = e.setContainerRef,
      r = e.setCanvasRef,
      u = a(e, ["setContainerRef", "setCanvasRef"]);
  return n.createElement("div", _i({
    ref: t,
    style: "className" in u ? void 0 : {
      width: "100%",
      height: "100%"
    }
  }, u), n.createElement("canvas", {
    ref: r
  }));
}

var o = {
  useDevicePixelRatio: !0,
  fitCanvasToArtboardHeight: !1
};

function c(e, a) {
  void 0 === a && (a = {});

  var c = t.useRef(null),
      s = t.useRef(null),
      f = t.useState(null),
      l = f[0],
      h = f[1],
      v = t.useState({
    height: 0,
    width: 0
  }),
      d = v[0],
      p = v[1],
      w = function () {
    var e = t.useState({
      width: 0,
      height: 0
    }),
        n = e[0],
        r = e[1];
    return t.useEffect(function () {
      if ("undefined" != typeof window) {
        var e = function e() {
          r({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };

        return window.addEventListener("resize", e), e(), function () {
          return window.removeEventListener("resize", e);
        };
      }
    }, []), n;
  }(),
      g = Boolean(e),
      b = function (e) {
    return Object.assign({}, o, e);
  }(a);

  function y() {
    if (s.current) {
      var e = function () {
        var e,
            t,
            n = null !== (t = null === (e = s.current) || void 0 === e ? void 0 : e.getBoundingClientRect()) && void 0 !== t ? t : new DOMRect(0, 0, 0, 0),
            r = n.width,
            i = n.height;

        if (l && b.fitCanvasToArtboardHeight) {
          var a = l.bounds;
          return {
            width: r,
            height: r * (a.maxY / a.maxX)
          };
        }

        return {
          width: r,
          height: i
        };
      }(),
          t = e.width,
          n = e.height,
          r = t !== d.width || n !== d.height;

      if (c.current && l && r) {
        if (b.fitCanvasToArtboardHeight && (s.current.style.height = n + "px"), b.useDevicePixelRatio) {
          var i = window.devicePixelRatio || 1;
          c.current.width = i * t, c.current.height = i * n, c.current.style.width = t + "px", c.current.style.height = n + "px";
        } else c.current.width = t, c.current.height = n;

        p({
          width: t,
          height: n
        }), l.startRendering();
      }

      l && l.resizeToCanvas();
    }
  }

  t.useEffect(function () {
    l && y();
  }, [l, w]);
  var R = t.useCallback(function (t) {
    if (t && e) {
      var n = new r.Rive(_i(_i({}, e), {
        canvas: t
      }));
      n.on(r.EventType.Load, function () {
        return h(n);
      });
    } else null === t && c.current && (c.current.height = 0, c.current.width = 0);

    c.current = t;
  }, [g]),
      m = t.useCallback(function (e) {
    s.current = e;
  }, []);
  t.useEffect(function () {
    var e = new IntersectionObserver(function (e) {
      e[0].isIntersecting ? l && l.startRendering() : l && l.stopRendering();
    });
    return c.current && e.observe(c.current), function () {
      e.disconnect();
    };
  }, [l]), t.useEffect(function () {
    return function () {
      l && (l.stop(), h(null));
    };
  }, [l]);
  var C = t.useCallback(function (e) {
    return n.createElement(u, _i({
      setContainerRef: m,
      setCanvasRef: R
    }, e));
  }, []);
  return {
    canvas: c.current,
    setCanvasRef: R,
    setContainerRef: m,
    rive: l,
    RiveComponent: C
  };
}

Object.keys(r).forEach(function (e) {
  "default" !== e && Object.defineProperty(exports, e, {
    enumerable: !0,
    get: function get() {
      return r[e];
    }
  });
}), exports.default = function (e) {
  var t = e.src,
      r = e.artboard,
      u = e.animations,
      o = e.layout,
      s = a(e, ["src", "artboard", "animations", "layout"]),
      f = c({
    src: t,
    artboard: r,
    animations: u,
    layout: o,
    autoplay: !0
  }).RiveComponent;
  return n.createElement(f, _i({}, s));
}, exports.useRive = c, exports.useStateMachineInput = function (e, n, r) {
  var i = t.useState(null),
      a = i[0],
      u = i[1];
  return t.useEffect(function () {
    if (e && n && r || u(null), e && n && r) {
      var t = e.stateMachineInputs(n);

      if (t) {
        var i = t.find(function (e) {
          return e.name === r;
        });
        u(i || null);
      }
    } else u(null);
  }, [e]), a;
};